module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><defs><style> .a { fill: #5e7e94; } </style></defs><title>icon-3</title><g><path class=\"a\" d=\"M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0m0,4.44A20.56,20.56,0,1,1,4.44,25,20.59,20.59,0,0,1,25,4.44\"></path><path class=\"a\" d=\"M35.25,24.4H26.61V14.72a2.25,2.25,0,0,0-4.49,0V25.51c0,.22.05.39.05.56a2.05,2.05,0,0,0-.05.55,2.24,2.24,0,0,0,2.24,2.23H35.25a2.23,2.23,0,1,0,0-4.45\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-3.svg
// module id = 536
// module chunks = 1